/**
 * DÓNDE ABREN LOS MENÚS DEL PIE DEL SIDEBAR: la bandeja y *My account* (21-oct-2026).
 *
 * > *"en el sidebar notification el apartado de my user"*
 *
 * En escritorio abren **a la derecha del botón**, con el borde de abajo alineado: el sidebar está a la izquierda y sobra
 * pantalla. En el teléfono el sidebar es un cajón pegado a la **derecha**, así que "a la derecha del botón" quedaba fuera
 * de la pantalla: se abrían y no se veían.
 *
 * 🔑 Si no cabe a la derecha, abre **encima del botón** y dentro de la pantalla. Mientras quepa, la regla de escritorio es
 * la misma de siempre.
 */

/** Aire contra el borde de la pantalla y contra el botón. */
const EDGE = 12;

export interface PopoverPosition {
  left: number;
  bottom: number;
  /** Solo cuando abre encima del botón: lo que cabe entre el botón y el borde de arriba. */
  maxHeight?: number;
}

export const besideOrAbove = (anchor: DOMRect, width: number): PopoverPosition => {
  const vw = document.documentElement.clientWidth || window.innerWidth;
  const vh = window.innerHeight;

  if (anchor.right + EDGE + width <= vw - EDGE) {
    return { left: anchor.right + EDGE, bottom: vh - anchor.bottom };
  }

  const shown = Math.min(width, vw - EDGE * 2);
  return {
    left: Math.max(EDGE, Math.min(anchor.left, vw - EDGE - shown)),
    bottom: vh - anchor.top + 8,
    maxHeight: Math.max(160, anchor.top - 8 - EDGE),
  };
};
